import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useFormik } from 'formik';
import { Typography } from "@mui/material";
import { toast } from 'react-toastify';
import useEncryption from '../../../services/useEncryption';
import useHeaders from '../../../helpers/useHeaders';
import { importReviewSchema } from '../../../services/formValidator/userValidator';
import useToast from '../../../helpers/useToast';
import { importReviewApi, getAllActiveProviderApi } from '../../../api/adminApi/adminApi';

const ImportReviewModel = ({ importOpen, handleClose }) => {
  const headers = useHeaders();
  const [providers, setProviders] = useState([]);
  const toastOptions = useToast();
  const { encryptData, decryptData  } = useEncryption();

  useEffect(() => {
    if(importOpen) {
        fetchData();
    }
}, [importOpen]);

const fetchData = async () => {

    try {
        const response = await getAllActiveProviderApi( headers )
        const decryptedData = decryptData(response?.data?.data);
        setProviders(decryptedData);
      
    } catch (error) {
        console.error('Error fetching data:', error);
    }
};

  const formik = useFormik({
    initialValues: {
      providerId: '',
      csvFile: '',
    },
    validationSchema: importReviewSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        const formData = new FormData();
        formData.append('providerId', values.providerId);
        formData.append('csvFile', values.csvFile);
        const response = await importReviewApi(formData); 
        handleClose();
        resetForm();
        toast.success(response.data.message,toastOptions);
      } catch (error) {
        toast.error(error.response.data.message, toastOptions);
      }
    }
  });


  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type === 'text/csv') { 
      formik.setFieldValue('csvFile', file);    
    } else {
      toast.error('Please upload a valid CSV file.', toastOptions);
    }
  };

  return (
    <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={importOpen}>
      <div className="d-flex align-items-center justify-content-between">
        <DialogTitle id="customized-dialog-title">Import Reviews</DialogTitle>
        <IconButton aria-label="close" onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </div>
      <DialogContent dividers>
        <form onSubmit={formik.handleSubmit} className="sectionalForms max-width-custom">
          <div className="row">

     

            <div className="col-lg-12 col-sm-12">
              <div className="formdesign">
                <FormControl fullWidth size="small" error={formik.touched.providerId && Boolean(formik.errors.providerId)}>
                  <InputLabel id="providerId-label">Provider</InputLabel>
                  <Select
                    labelId="providerId-label"
                    id="providerId"
                    name="providerId"
                    value={formik.values.providerId}
                    label="Provider"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  >
                    {providers.map((provider) => (
                        <MenuItem key={provider?.id} value={provider?.id}>
                            {provider?.organizationName}
                        </MenuItem>
                    ))}
                  </Select>
                  {formik.touched.providerId && formik.errors.providerId && (
                    <Typography variant="caption" color="error" style={{ marginLeft: "15px", marginTop: "4px" }}>
                      {formik.errors.providerId}
                    </Typography>
                  )}
                </FormControl>
              </div>
            </div>

            {/* File Upload Input */}
            <div className="col-lg-12 col-sm-12 mt-3">
              <div className="formdesign">
                <input
                  accept=".csv"
                  id="csvFile"
                  name="csvFile"
                  type="file"
                  onChange={handleFileChange}
                  onBlur={formik.handleBlur}
                  className="form-control"
                />
                {formik.touched.csvFile && formik.errors.csvFile && (
                  <Typography variant="caption" color="error" style={{ marginLeft: "15px", marginTop: "4px" }}>
                    {formik.errors.csvFile}
                  </Typography>
                )}
              </div>
            </div>


          </div>
        </form>
      </DialogContent>
      <DialogActions>
        <div className="text-end modalactions">
          <button className="btn btn-blacked outline me-2" onClick={handleClose}>Cancel</button>
          <button className="btn btn-blacked" onClick={formik.handleSubmit}>Submit</button>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default ImportReviewModel;